import { useNavigate, useParams } from "react-router";
import { useAuth } from "@/auth/AuthContext";
import { CreateEntityModal } from "@/components/CreateEntityModal";
import { Chip } from "@/components/Chip";
import { hasRole } from "@/lib/hasRole";
import { EntityListPage } from "./EntityListPage";
import { useEntityList } from "./useEntityList";

interface Gateway {
  id: string;
  name: string;
  source: string;
  createdAt: string;
  lastSeenAt: string | null;
  publicUrl: string | null;
  platform: string | null;
}

export function Gateways() {
  const { user } = useAuth();
  const { orgId } = useParams();
  const navigate = useNavigate();
  const list = useEntityList<Gateway>("gateways");
  const isAdmin = hasRole(user?.roles, "Admin");

  return (
    <>
      {isAdmin && <CreateEntityModal entityType="gateway" />}

      <EntityListPage
        list={list}
        entityLabel="gateway"
        entityLabelPlural="gateways"
        emptyDescription="Gateways accept connections and route them to your resources."
        identityMeta={(gateway) =>
          [gateway.publicUrl, gateway.platform].filter(Boolean).join(" · ") ||
          null
        }
        extraColumns={[
          {
            header: "Type",
            render: (gateway) => (
              <Chip>
                {gateway.source === "Hosted" ? "Hosted" : "Self-hosted"}
              </Chip>
            ),
          },
        ]}
        menuItems={
          isAdmin
            ? (gateway) => [
                {
                  label: "Details",
                  onClick: () =>
                    navigate(
                      `/${orgId}/networking/gateways/${gateway.id}/details`,
                    ),
                },
                {
                  label: "Resources",
                  onClick: () =>
                    navigate(
                      `/${orgId}/networking/gateways/${gateway.id}/resources`,
                    ),
                },
                ...(gateway.source === "SelfHosted"
                  ? [
                      {
                        label: "Settings",
                        onClick: () =>
                          navigate(
                            `/${orgId}/networking/gateways/${gateway.id}/settings`,
                          ),
                      },
                    ]
                  : []),
              ]
            : undefined
        }
      />
    </>
  );
}
